import * as ko from "knockout";
import Bao from "./../../../services/bao-service";
import BaoDialogViewModel from "./../../../factories/bao-dialog";
function AuditViewModel(tabPage, auditUrl, objectId) {
    var self = this;
    self.Bao = Bao;
    self.TabPage = tabPage;
    self.AuditUrl = auditUrl;
    self.ObjectId = objectId;
    self.AuditCollection = ko.observableArray([]);
    self.PageIndex = ko.observable(0);
    self.PageSize = ko.observable(20);
    self.Sorting = ko.observableArray([]);
    self.Sorting.subscribe(function () {
        self.Refresh();
    });
    self.PageIndex.subscribe(function () {
        self.Refresh();
    });
    self.TotalRows = ko.observable();
    self.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
    self.Dialog.Width("800px");
    self.Dialog.Buttons([{
            Title: Bao.Session.GetMessage("msgOk"),
            Click: function () {
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }]);
    self.DialogViewModel = {};
    self.DialogViewModel.Bao = Bao;
    self.Refresh = function () {
        return Bao.post(self.AuditUrl, JSON.stringify({
            objectId: self.ObjectId,
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: self.Sorting()
        }), function (result) {
            self.AuditCollection(result.Models);
            self.TotalRows(result.TotalRows);
        });
    };
    self.Show = function () {
        tabPage.IsLoading(true);
        return Bao.post("Uadm/Application/AuditDialog", JSON.stringify({}), function (value) {
            self.Dialog.ViewModel(self);
            self.Dialog.Template(value);
            self.Refresh();
            self.Dialog.Open();
            tabPage.IsLoading(false);
        });
    };
}
export default AuditViewModel;